import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MoveWardrobeContext } from '../../contexts/MoveWardrobeContext';

const MoveWardrobe = props => {
  const { moveSegment } = props;
  const { shifts, setShifts } = useContext(MoveWardrobeContext);

  const changeShift = dir => {
    moveSegment(dir);
    setShifts({ ...shifts, shift: !shifts.shift });
  };

  return (
    <div className="move-wardrobe">
      <p className="move-wardrobe__instruction">Przenieś szafę w prawo lub lewo</p>
      <button
        className={`move-wardrobe__btn ${!shifts.left ? 'icon-block' : ''}`}
        onClick={() => changeShift('L')}>
        <span className="icon-left-arrow" />
      </button>
      <button
        className={`move-wardrobe__btn ${!shifts.right ? 'icon-block' : ''}`}
        onClick={() => changeShift('R')}>
        <span className="icon-right-arrow" />
      </button>
    </div>
  );
};

MoveWardrobe.propTpes = {
  moveSegment: PropTypes.func.isRequired,
};

export default MoveWardrobe;
